import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useThemeContext } from '#contexts/ThemeContext';
import { Box, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
const useStyles = (progressBarColor) => makeStyles(() => ({
    barColorPrimary: {
        backgroundColor: progressBarColor
    }
}));
export const QuestionnaireProgress = ({ total, step }) => {
    const { progressBar } = useThemeContext();
    const [perProgress, setPerProgress] = React.useState(1);
    const progressLabelId = 'questionnaire-progress-label';
    const classes = useStyles(progressBar)();
    React.useEffect(() => {
        total && setPerProgress(calculatePercentage(step, total));
    }, [total, step]);
    return (_jsxs(Box, { className: 'shadow shadow-lg swyft-box-shadow', mb: 2, bgcolor: '#ffffff', children: [_jsxs("span", { id: progressLabelId, style: { position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }, children: ["Questionnaire progress: Step ", step, " of ", total] }), _jsx(LinearProgress, { classes: classes, variant: 'determinate', value: perProgress, "aria-labelledby": progressLabelId, role: "progressbar" })] }));
};
const calculatePercentage = (step, total) => {
    return (step / total) * 100;
};
